import React from 'react';
import { Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Header from '../../Header';
import Intro from './Intro';
import Scales from './Scales';
import Clinicians from './Clinicians';
import Patients from './Patients';
import Visits from './Visits';
import Assessments from './Assessments';
import Answers from './Answers';

export default class ApiIndex extends React.Component {
  isActive = term => {
    const path = this.props.location.pathname.split('/').pop();
    return path === term;
  }

  render() {
    return (
     <section>
      <Header {...this.props} /> 
      <div className="container has-text-centered">
         <section className="section">
          <div className="container has-text-left">
            <h1 className="title">CCI API Documentation</h1>
            <div className="columns is-desktop">
              <div className="column is-4 is-hidden-mobile is-hidden-tablet-only">
                <aside className="menu">
                  <ul className="menu-list">
                    <li><Link to="/api/intro" className={classNames({
                      'is-active': this.isActive('intro')
                    })}>Introduction</Link></li>
                    <li><Link to="/api/scales" className={classNames({
                      'is-active': this.isActive('scales')
                    })}>Scales</Link></li>
                    <li><Link to="/api/clinicians" className={classNames({
                      'is-active': this.isActive('clinicians')
                    })}>Clinicians</Link></li>
                    <li><Link to="/api/patients" className={classNames({
                      'is-active': this.isActive('patients')
                    })}>Patients</Link></li>
                    <li><Link to="/api/visits" className={classNames({
                      'is-active': this.isActive('visits')
                    })}>Visits</Link></li>
                    <li><Link to="/api/assessments" className={classNames({
                      'is-active': this.isActive('assessments')
                    })}>Assessments</Link></li>
                    <li><Link to="/api/answers" className={classNames({
                      'is-active': this.isActive('answers')
                    })}>Answers</Link></li>
                    </ul>
                </aside>
              </div>
              <div className="column">
                <Switch>
                  <Route path="/api/intro" component={Intro} />
                  <Route path="/api/scales" component={Scales} />
                  <Route path="/api/clinicians" component={Clinicians} />
                  <Route path="/api/patients" component={Patients} />
                  <Route path="/api/visits" component={Visits} />
                  <Route path="/api/assessments" component={Assessments} />
                  <Route path="/api/answers" component={Answers} />
                </Switch>    
              </div>
            </div>
          </div>
        </section>                
      </div>
    </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Index.js